module.exports = __webpack_public_path__ + "img/htfywb_img.65dd70ed.png";